import enrollCmd from "../base/enrollCmd";

/**
 * Nothing to fancy here, just checks input values and builds the JSON to send to plugin manager
 * @param formatType
 */
export const enrollExtensionMsg = () => {
    const enrolMessage = "{'enrollType':'" + enrollCmd.CMD_EXTENSION + "','type':'enroll'}";
    return enrolMessage;
};

/**
  * converts the message to object type.
  * @param {*} obj
  */
export const decodeExtensionPluginMsg = (obj) => {
    // TODO
};